import React, {FC} from "react"

import id from "@irati/utils/id"
import ProfilePicture from "@irati/ui/src/ProfilePicture"
import {User} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

interface Props {
  user: User,
  id?: string,
  isMenuDisplayed?: boolean
}

const UserMenuTitle: FC<Props> = (props) => {
  const {user, isMenuDisplayed} = props
  const idNamespace = id("desktop", props)

  return (
    <Flex alignItems="center" justifyContent="space-between" minWidth="40px">
      <Flex alignItems="center">
        <ProfilePicture id={id("user-profile", idNamespace)} user={user} marginRight small />
      </Flex>
      <Icon icon={isMenuDisplayed ? IconTypes.chevronUp : IconTypes.chevronDown} id={id("arrowDown", idNamespace)} />
    </Flex>
  )
}

export default UserMenuTitle
